<template>
	<div class="modal-column">
		<div class="modal-column-body">
			<Form mode="block" ref="form" :rules="{}" :model="formData">
				<div class="inline-form-item">
					<FormItem label="编码" prop="code" required>
						<NumberInput v-model="formData.code"/>
					</FormItem>
					<FormItem label="名称" prop="name" required>
						<Input type="text" v-model.trim="formData.name"/>
					</FormItem>
				</div>
				<div class="inline-form-item">
					<FormItem label="负责人" prop="leader">
						<Input type="text" v-model="formData.leader"/>
					</FormItem>
					<FormItem label="手机" prop="telPhone">
						<Input type="text" v-model="formData.telPhone"/>
					</FormItem>
				</div>
				<div class="inline-form-item">
					<FormItem label="成立日期" prop="startDate">
						<DatePicker v-model="formData.startDate"/>
					</FormItem>
					<FormItem label="撤销日期" prop="endDate">
						<DatePicker v-model="formData.endDate"/>
					</FormItem>
				</div>
				<FormItem label="备注" prop="remark">
					<Input type="text" v-model="formData.remark"/>
				</FormItem>
			</Form>
		</div>
		<div class="modal-column-btn modal-column-between">
			<vxe-button :loading="loading" icon="fa fa-close" @click="$emit('close')">取消</vxe-button>
			<div>
				<vxe-button :loading="loading" status="primary" icon="fa fa-save" @click="onSave(false)">保存</vxe-button>
				<vxe-button v-if="!formData.id" :loading="loading" status="primary" icon="fa fa-save" @click="onSave(true)">保存并新增</vxe-button>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
	name: "DepartmentForm"
}
</script>

<script setup>
import {reactive, ref, defineEmits, defineProps, toRefs} from "vue";
import {Department} from "@/api/Auxiliary";
import {message} from "heyui.ext";
import {CopyObj} from "@/js/common/utils";

const emit = defineEmits(['close', 'success'])
const props = defineProps(['entity'])

const {entity} = toRefs(props)
const loading = ref(false);
const form = ref(null);

const formData = reactive({
	id: null,
	code: null,
	enable: true,
	name: null,
	remark: null,
	endDate: null,
	leader: null,
	startDate: null,
	telPhone: null,
})

const onSave = (add = false) => {
	const validResult = form.value.valid();
	if (validResult.result) {
		loading.value = true;
		Department.save(formData).then(() => {
			if(add){
				message("保存成功~")
				formData.id = null;
				formData.code = null;
				formData.enable = true;
				formData.name = null;
				formData.remark = null;
				formData.endDate = null;
				formData.leader = null;
				formData.startDate = null;
				formData.telPhone = null;
			}else{
				message("保存成功~")
				emit('success')
			}
		}).finally(() => loading.value = false)
	}
}

CopyObj(formData, entity.value);
</script>
